module.exports = __webpack_public_path__ + "img/Vermisste_Person.ce9b1109.svg";